<template>
    <div :class="['model_viewer', isFullScreen ? 'full' : '']">
        <div class="container" ref="container"></div>
        <div class="btns">
            <span @click="reset">复位</span>
            <span v-if="status.hasAnimation" :class="{ active: status.animation }"
                @click="playAnimation(!status.animation)">动画</span>
            <span :class="{ active: status.wireframe }" @click="setWireframe(!status.wireframe)">网格</span>
            <span :class="{ active: status.dimension }" @click="setDimension(!status.dimension)">尺寸</span>
            <span :class="{ active: status.rotation }" @click="setRotation(!status.rotation)">旋转</span>

            <!-- 背景菜单区域，增加mouseleave事件监听 -->
            <span class="back" ref="backMenu" @click.stop="toggleBackMenu" @mouseleave="handleBackMenuMouseLeave">
                <i>背景</i>
                <ul v-show="showBackMenus">
                    <li @click.stop="() => { setBackground(0); showBackMenus = false }"
                        :class="{ active: status.background == 0 }">默认</li>
                    <li @click.stop="() => { setBackground(2); showBackMenus = false }"
                        :class="{ active: status.background == 2 }">深色</li>
                    <li @click.stop="() => { setBackground(1); showBackMenus = false }"
                        :class="{ active: status.background == 1 }">浅色</li>
                </ul>
            </span>
            <!-- <i class="iconfont icon-quanping" @click="fullscreen(true)"></i> -->
             <button @click="fullscreen"><van-icon :name="require('@/assets/imgs/icon63.png')" size="16rem" /></button>
        </div>
        <div class="progress" v-if="progress < 100">
            <van-progress :percentage="progress" stroke-width="8" />
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, reactive, onBeforeUnmount } from "vue";

const props = defineProps({
    url: '',
    background: ''
})

const backgrounds = [
    'https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/images/background01.png',
    'https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/images/background02.png',
    'https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/images/background03.png'
]

const container = ref(null)
const isFullScreen = ref(false)
const showBackMenus = ref(false)
const backMenu = ref(null)
const status = reactive({
    wireframe: false,
    dimension: false,
    rotation: false,
    animation: false,
    hasAnimation: false,
    background: 0
})

let model, viewer, dimension

// 切换背景菜单展开/收起（点击按钮时触发）
const toggleBackMenu = () => {
    showBackMenus.value = !showBackMenus.value
}

// 鼠标离开背景菜单区域时触发，收起菜单
const handleBackMenuMouseLeave = () => {
    showBackMenus.value = false
}

// 全局点击判断（点击外部关闭菜单）
const handleDocumentClick = (e) => {
    const isClickInside = backMenu.value && backMenu.value.contains(e.target)
    if (!isClickInside) {
        showBackMenus.value = false
    }
}
const progress = ref(0)
onMounted(() => {
    if (props.url) {
        viewer = new SDK.Viewer(container.value)
        viewer.addEventListener('update', viewer.controls.update)
        viewer.controls.enableDamping = true
        viewer.sceneManager.setBackground(props.background || backgrounds[0])
        viewer.scene.background.colorSpace = SDK.LinearSRGBColorSpace
        console.log('模型加载中：', props.url);
        loadModel(props.url)
    }
    window.document.addEventListener('click', handleDocumentClick)
})

function loadModel(url) {
    progress.value = 0
    viewer.sceneManager.loader.loadModel(url, {
        onProgress: (e) => {
            progress.value = Math.ceil(e.loaded / e.total * 100)
            
        }
    }).then(m => {
        console.log('模型加载完成：', m);
        viewer.fitCamera(m)
        model = m
        viewer.sceneManager.setEnvMap(viewer.sceneManager.roomEnvironment)
        viewer.sceneManager.setEnvMapIntensity(1)
        viewer.sceneManager.ambientLight.intensity = 1
        SDK.ShadowHelper.createShadow(model, viewer)
        status.hasAnimation = model.animation.animationClips.length > 0
        setRotation(true)
    })
}

onBeforeUnmount(() => {
    if (viewer) viewer.dispose()
    window.document.removeEventListener('click', handleDocumentClick)
})

const setWireframe = function (value) {
    status.wireframe = value
    model.materials.map(mat => {
        mat.wireframe = value
    })
}

const setDimension = function (value) {
    if (!dimension) {
        const v3 = new SDK.Box3().setFromObject(model).getSize()
        dimension = new SDK.Dimensions(model, v3.x.toFixed(2) + '米', v3.z.toFixed(2) + '米', v3.y.toFixed(2) + '米', '#333')
    }
    status.dimension = value
    if (value) {
        viewer.root.add(dimension)
    } else {
        viewer.root.remove(dimension)
    }
}

const setRotation = function (value) {
    status.rotation = value
    if (value) {
        viewer.controls.rotateAround(30 * 1000)
    } else {
        viewer.controls.stopRotateAround()
    }
}

const fullscreen = function (value) {
    // var previewUrl = props.url
    // previewUrl = previewUrl.replace('https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/', '').replace('index.3dw', '')
    // window.open(window.location.origin + '/modelshare?path=' + encodeURIComponent(previewUrl))
    isFullScreen.value = !isFullScreen.value
    requestAnimationFrame(() => {
        viewer.resize()
    })
}

const playAnimation = function (value) {
    status.animation = value
    if (value) {
        model.animation.play(model.animation.animationClips[0])
    } else {
        model.animation.stopAll()
    }
}

const setBackground = function (index) {
    status.background = index
    viewer.sceneManager.setBackground(index == 0 ? (props.background || backgrounds[0]) : backgrounds[index])
}

const reset = function () {
    setWireframe(false)
    setDimension(false)
    setRotation(false)
    setBackground(0)
}
</script>

<style lang="scss" scoped>
.model_viewer {
    width: 100%;
    height: 100%;
    background-color: #ccc;
    position: relative;

    .container {
        width: 100%;
        height: 100%;
    }

    .btns {
        position: absolute;
        bottom: 10rem;
        right: 0;
        display: flex;
        align-items: center;
        padding: 0 10rem;

        span {
            display: inline-block;
            width: 52rem;
            height: 24rem;
            line-height: 24rem;
            font-size: 14rem;
            color: #FFF;
            background-color: #333333;
            margin: 0 5rem;
            text-align: center;
            border-radius: 3rem;
            cursor: pointer;
            user-select: none;
        }

        button{
            background-color: transparent; border: none;
        }
        li, i {
            font-size: 14rem;
        }

        .active {
            background-color: #726FF9;
        }

        .iconfont {
            font-size: 28rem;
            margin-left: 5rem;
            color: #FFF;
            cursor: pointer;
        }

        .back {
            position: relative;

            i {
                display: inline-block;
                width: 100%;
                height: 100%;
                cursor: pointer;
            }

            ul {
                position: absolute;
                width: 100%;
                bottom: 24rem;
                left: 0;
                margin: 0;
                padding: 0;
                list-style: none;
                z-index: 10;

                li {
                    width: 100%;
                    background-color: #333333;
                    height: 24rem;
                    line-height: 24rem;
                    color: #FFF;
                    text-align: center;
                    cursor: pointer;
                    border-radius: 0;
                }

                li.active {
                    background-color: rgba(10, 132, 255, 0.8);
                }

                li:hover {
                    background-color: #444;
                }
            }
        }
    }
}

.full {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
}
.progress{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,0.5);
    .van-progress{
        width: 80%;
    }
}
</style>